/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {markSuggestedActionUsed} from '../api'

export const useMutationMarkSuggestedActionUsed = createReactQueryMutationHook('markSuggestedActionUsed', markSuggestedActionUsed)
